namespace advisorop.domains {
    "use strict";

    export interface IAdvisoryFirmServicer {
        id?: number;
        advisoryFirmId?: number;
        servicerId?: string;
    }
}
